import React, { Component } from 'react';
import { substrByBytes } from './utils';
import { Right, CenterBlock } from './ui';
import GroupAddOrEdit from './group/addOrEdit';

export default class extends Component {
    state = {};

    tigger(type) {
        switch (type) {
            case "shrink": //收缩
                this.setState({
                    expanded: false
                });
                break;
            default:
                break;
        }
    }

    onToggle() {
        this.setState({
            expanded: !this.state.expanded
        });
    }

    onQuit() {
        const { session, onQuit } = this.props;

        this.tigger('shrink');
        onQuit && onQuit(session);
    }

    onCancel() {
        this.tigger('shrink');
    }

    render() {
        const { user, session, userData, sessionActions, groupActions, onClose, onSaveGroup } = this.props;
        let expanded = this.state.expanded;
        let iconExpandClassName = "icon font-xs icon-arrow-" + (expanded ? "up" : "down");

        return (
            <header>
              <CenterBlock>
                {
                  <a onClick={this.onToggle.bind(this)}>
                    {substrByBytes(session.name, 22)} <i className={iconExpandClassName}></i>
                  </a>
                }
                <Right>
                  <a className="icon icon-close" onClick={onClose&&onClose.bind(this, session)}></a>
                </Right>
              </CenterBlock>
              { expanded ? (
                    <GroupAddOrEdit user={user}
                                    session={session} 
                                    userData={userData} 
                                    sessionActions={sessionActions} 
                                    groupActions={groupActions}
                                    onSave={onSaveGroup}
                                    onQuit={this.onQuit.bind(this)}
                                    onCancel={this.onCancel.bind(this)}/> 
                ) : null 
              }
            </header>
        )
    }
}


// WEBPACK FOOTER //
// ./src/header.js